import ErrorIcon from '@mui/icons-material/Error';

const RedExclamationIcon = () => {
	return <ErrorIcon style={{ color: 'red' }} />;
};

export default RedExclamationIcon;
